import { KeyboardArrowDown } from "@mui/icons-material";

import AutoCompleteDropdown from "../../../../../../ui library/components/dropdowns/AutoCompleteDropdown";
import HNSColors from "../../../../../../ui library/HNSColors";
import { STYLES } from "../../../utils/customStyles";

export default function SingleSelectDropdown({
  placeholder = "",
  fieldName,
  fieldValue,
  onChange,
  data,
}) {
  const selectedOption = data.find((option) => String(option.id) === String(fieldValue));
  return (
    <AutoCompleteDropdown
      data={data}
      initValue={selectedOption}
      getOptionLabel={(option) => option?.label || ""}
      isOptionEqualToValue={(option, optionValue) =>
        option?.id === optionValue?.id || option === optionValue
      }
      renderTags={null}
      placeholder={placeholder}
      onValueChange={(_, value) => {
        onChange(fieldName, value?.id ?? null);
      }}
      ListboxProps={{
        sx: {
          maxHeight: 200,
          overflow: "auto",
          "&::-webkit-scrollbar": { width: "6px" },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: HNSColors.primary[500],
            borderRadius: "3px",
          },
        },
      }}
      textFieldSx={STYLES.textField}
      selectProps={{
        IconComponent: (props) => (
          <KeyboardArrowDown {...props} sx={{ fontSize: 24, color: HNSColors.primary[500] }} />
        ),
      }}
      dropdownSx={STYLES.selectMenuPaper}
    />
  );
}
